import React, { useEffect, useRef, useState } from "react"
import anime from "animejs"
import classNames from "classnames"
import { noop } from "lodash-es"
import { create } from "zustand"

import { useWebM } from "@/topic/rogue_5/pages/Lobby/building"
import { sleep } from "@/topic/rogue_5/utils/misc"
import { SFX } from "@/topic/rogue_5/utils/sfx"
import { supportsHEVCAlpha } from "@/utils/misc"
import HandWebm from "../../../../../assets/img/game/modal/effect/handAnimation.webm"

import HandMp4 from "../../../../../assets/img/game/modal/effect/handAnimation.mp4"
import HandApng from "../../../../../assets/img/game/modal/effect/handAnimation.png"
import styles from "./index.module.less"

const animate = async (ele: HTMLDivElement) => {
    const maskTop = ele.querySelector(`.${styles.maskTop}`)
    const maskBottom = ele.querySelector(`.${styles.maskBottom}`)
    // const handLeft = ele.querySelector(`.${styles.handLeft}`)
    // const handRight = ele.querySelector(`.${styles.handRight}`)
    const shadow = ele.querySelector(`.${styles.shadow}`)
    const handAnimation = ele.querySelector(`.${styles.handAnimation}`)
    ele.classList.add(styles.active)

    SFX.play("handIn")
    const timeline = anime.timeline()
    timeline.add(
        {
            targets: maskTop,
            translateY: ["-105%", "0%"],
            duration: 1200,
            easing: "easeOutCubic",
        },
        0
    )
    timeline.add(
        {
            targets: maskBottom,
            translateY: ["105%", "0%"],
            duration: 1200,
            easing: "easeOutCubic",
        },
        0
    )
    // timeline.add(
    //     {
    //         targets: handLeft,
    //         opacity: [0, 1],
    //         duration: 800,
    //         easing: "easeOutCubic",
    //     },
    //     0
    // )
    // timeline.add(
    //     {
    //         targets: handRight,
    //         opacity: [0, 1],
    //         duration: 800,
    //         easing: "easeOutCubic",
    //     },
    //     0
    // )
    // const handEasing = "cubicBezier(0.3, 0.5, 0.5, 1.0)"
    // timeline.add(
    //     {
    //         targets: handLeft,
    //         translateX: ["-50%", "0%"],
    //         scaleX: [-1, -1],
    //         duration: 2000,
    //         easing: handEasing,
    //     },
    //     0
    // )
    // timeline.add(
    //     {
    //         targets: handRight,
    //         translateX: ["50%", "0%"],
    //         duration: 2000,
    //         easing: handEasing,
    //     },
    //     0
    // )
    timeline.add(
        {
            targets: shadow,
            opacity: [0, 1],
            scale: [1.2, 1],
            duration: 1200,
            easing: "easeOutCubic",
        },
        0
    )
    timeline.add(
        {
            targets: handAnimation,
            translateY: ["0%", "0%"],
            duration: 100,
            easing: "easeOutCubic",
        },
        0
    )
    return timeline.finished
}

const exit = async (ele: HTMLDivElement) => {
    const maskTop = ele.querySelector(`.${styles.maskTop}`)
    const maskBottom = ele.querySelector(`.${styles.maskBottom}`)
    // const handLeft = ele.querySelector(`.${styles.handLeft}`)
    // const handRight = ele.querySelector(`.${styles.handRight}`)
    const shadow = ele.querySelector(`.${styles.shadow}`)
    const handAnimation = ele.querySelector(`.${styles.handAnimation}`)
    ele.classList.remove(styles.active)

    const timeline = anime.timeline()
    // timeline.add(
    //     {
    //         targets: maskTop,
    //         translateY: ["0%", "-40%"],
    //         duration: 500,
    //         easing: "easeOutCubic",
    //     },
    //     0
    // )
    // timeline.add(
    //     {
    //         targets: maskBottom,
    //         translateY: ["0%", "40%"],
    //         duration: 500,
    //         easing: "easeOutCubic",
    //     },
    //     0
    // )
    // timeline.add(
    //     {
    //         targets: handLeft,
    //         translateX: ["0%", "-10%"],
    //         scaleX: [-1, -1],
    //         duration: 500,
    //         easing: "easeOutCubic",
    //     },
    //     0
    // )
    // timeline.add(
    //     {
    //         targets: handRight,
    //         translateX: ["0%", "10%"],
    //         duration: 500,
    //         easing: "easeOutCubic",
    //     },
    //     0
    // )
    timeline.add(
        {
            targets: handAnimation,
            translateY: ["0%", "20%"],
            duration: 500,
            easing: "easeOutCubic",
        },
        0
    )
    return timeline.finished
}

const useEffectModalStore = create<{
    activate: (onExit?: () => void) => void
}>(() => ({
    activate: noop,
}))

export const useEffectModal = () =>
    useEffectModalStore((state) => state.activate)

const EffectModal: React.FC<{
    className?: string
    style?: React.CSSProperties
}> = ({ className, style }) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const animating = useRef(false)
    const [apngActive, setApngActive] = useState(false)
    useEffect(() => {
        useEffectModalStore.setState({
            activate: (onExit) => {
                if (animating.current) return
                setApngActive(true)
                animating.current = true
                animate(containerRef.current!).then(async () => {
                    await sleep(1200)
                    animating.current = false
                    onExit?.()
                    await sleep(200)
                    exit(containerRef.current!).then(() => {
                        setApngActive(false)
                    })
                })
            },
        })
    }, [])
    return (
        <div
            className={classNames(styles.modalContainer, className)}
            style={style}
            ref={containerRef}
        >
            <div className={styles.maskTop} />
            <div className={styles.maskBottom} />
            <div className={styles.shadow} />
            {/* <div className={styles.handLeft} /> */}
            {/* <div className={styles.handRight} /> */}
            {apngActive ? (
                useWebM || supportsHEVCAlpha() ? (
                    <video
                        autoPlay
                        muted
                        playsInline
                        preload="auto"
                        className={styles.handAnimation}
                    >
                        <source src={HandMp4} type="video/quicktime" />
                        <source src={HandWebm} type="video/webm" />
                    </video>
                ) : (
                    <img src={HandApng} className={styles.handAnimation} />
                )
            ) : null}
        </div>
    )
}

export default EffectModal
